@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"); 

/* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */
.colSmHeader {
  background-color: #fff;
}
.icon-image {
  /* border-top-left-radius: 5px; */
  width: 45px;
}

.section-title {
  font-size:16px;
  margin-left:5px;
}
.section-bg {

  border-bottom: 1px solid #CE2127;
  height: 45px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

a , a:visited {
  color: #b71d1d;
  font-size: 16px;
  text-decoration: none;
}

a:hover {
  color: #b71d1d;
  font-size: 16px;
 
}
